<swiper
    [autoplay]="{ delay: 2500, disableOnInteraction: false }"
    [breakpoints]="breakpoints"
    [loopFillGroupWithBlank]="true"
    [loop]="true"
    [navigation]="isNavigationEnabled"
    [pagination]="isPaginationEnabled ? { clickable: true } : undefined"
    [slidesPerView]="1"
    [spaceBetween]="10">
  <ng-template *ngFor="let screenshot of screenshots" swiperSlide>
    <div (click)="openScreenshot(screenshot.src)" class="content">
      <img [src]="screenshot.src" alt="logo" class="brand-logo" height="auto"
           width="auto"/>
      <p>{{ screenshot.description }}</p>
    </div>
  </ng-template>
</swiper>
